/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Metrics from 'services/metrics';
import { getRegion } from 'utils/Region';
import * as actions from '../../actions/response';
import PanelClaro from '../forms/PanelClaro';
import LoadingBlocks from '../forms/LoadingBlocks';
import { converter } from '../../helpers/converter';
import * as constants from '../../constants';
import Utils from '../../utils/Utils';

export class UnSuscribeSection extends React.Component {
  setExpirationDate() {
    const paywayData = this.props.extradata.payway;
    if (paywayData.expiration_date) {
      const dateSimple = paywayData.expiration_date.split(' ');
      return dateSimple[0];
    }
    if (paywayData.expiration) {
      const dateSimple = paywayData.expiration.split(' ');
      return dateSimple[0];
    }

    return '';
  }

  isClaro() {
    return (
      this.props.extradata.provider &&
      this.props.extradata.provider.startsWith('CV_')
    );
  }

  isItunes() {
    return (
      this.props.extradata.payway &&
      this.props.extradata.payway.gateway &&
      this.props.extradata.payway.gateway === 'itunesgate'
    );
  }

  getTextsKey() {
    return this.isItunes() && this.isClaro() ? 'itunesgate' : 'default';
  }

  onCancel = () => {
    const texts = this.getTextsKey();
    Metrics.newEvent({
      eventCategory: 'Suscripción',
      eventAction: this.props.extradata.provider,
      eventLabel: 'Cancelar Suscripción',
    });
    // aqui empieza el hardcodeo neta hay que cambiarlo cuando tengamos llaves
    const modal = {
      modalType: 'UnSuscribeConfirm',
      props: {
        title: converter.convertApaUnicode(
          this.props.translations,
          this.props.extradata.texts[texts].cancellation_dialog.dialog_title,
          'Cancela tu Suscripci&oacute;n',
        ),
        message: converter.convertApaUnicode(
          this.props.translations,
          this.props.extradata.texts[texts].cancellation_dialog
            .dialog_description,
          '¿Estás seguro que deseas cancelar tu Suscripci&oacute;n?',
        ),
        nobtn: converter.convertApaUnicode(
          this.props.translations,
          this.props.extradata.texts[texts].cancellation_dialog
            .dialog_button_no,
          'NO, VOLVER.',
        ),
        sibtn: converter.convertApaUnicode(
          this.props.translations,
          this.props.extradata.texts[texts].cancellation_dialog
            .dialog_button_yes,
          'SI.',
        ),
        dowsellbtn: converter.convertApaUnicode(
          this.props.translations,
          this.props.extradata.texts[texts].cancellation_dialog
            .dialog_button_downsell,
          'Downsell.',
        ),
        purchase_id: this.props.extradata.payway
          ? this.props.extradata.payway.purchase_id
          : null,
        provider: this.props.extradata.provider,
        extradata: this.props.extradata,
        userInfo: this.props.user.info,
        fingerprint: this.props.fingerprint,
      },
    };
    this.props.showModal(modal);
  };

  render() {
    if (!this.props.extradata.payway && !this.props.translations) {
      return null;
    }

    if (
      this.props.extradata.payway &&
      this.props.extradata.payway.purchase_data
    ) {
      this.props.extradata.payway.purchase_data.price = this.props.extradata.payway.price;
      this.props.extradata.payway.purchase_data.currency = this.props.extradata.payway.currency;
      this.props.extradata.payway = this.props.extradata.payway.purchase_data;
    }

    const texts = this.getTextsKey();

    let textDesc =
      'Actualmente estás disfrutando la suscripción a {@PROVIDER} con cargo a tu {@MEDIOPAGO}, hasta el {@EXPIRATION}';
    let optionalTitle = 'Suscripcion';
    if (
      this.props.extradata &&
      this.props.extradata.provider &&
      constants.VENDORS_DEMO &&
      constants.VENDORS_DEMO[this.props.extradata.provider]
    ) {
      optionalTitle = `Suscripcion ${
        constants.VENDORS_DEMO[this.props.extradata.provider]
      }`;
    }

    if (
      this.props.extradata &&
      this.props.extradata.texts &&
      this.props.extradata.texts[texts] &&
      this.props.extradata.texts[texts].offer_description &&
      this.props.extradata.texts[texts].offer_description.purchased
    ) {
      if (
        this.props.translations &&
        this.props.translations[
          this.props.extradata.texts[texts].offer_description.purchased
        ]
      ) {
        textDesc = converter.convertApaUnicode(
          this.props.translations,
          this.props.extradata.texts[texts].offer_description.purchased,
        );
      }
    }

    let proveedor = 'Claro';
    let gateway = ' medio de pago';

    const payway = this.props.extradata.payway || {};

    if (
      this.props.extradata &&
      this.props.extradata.provider &&
      constants.VENDORS_DEMO &&
      constants.VENDORS_DEMO[this.props.extradata.provider]
    ) {
      proveedor = constants.VENDORS_DEMO[this.props.extradata.provider];
    }

    if (
      this.props.translations &&
      this.props.extradata &&
      this.props.extradata.provider &&
      this.props.translations[this.props.extradata.provider]
    ) {
      proveedor = converter.convertApaUnicode(
        this.props.translations,
        this.props.extradata.provider,
      );
    }

    if (
      this.props.extradata &&
      this.props.extradata.payway &&
      this.props.extradata.payway.gateway &&
      constants.GATEWAYS_DEMO &&
      constants.GATEWAYS_DEMO[this.props.extradata.payway.gateway]
    ) {
      if (this.props.config.skin === 'sk_brasil') {
        gateway = 'telefone móvel';
      } else {
        gateway = constants.GATEWAYS_DEMO[this.props.extradata.payway.gateway];
      }
    }

    if (
      this.props.extradata &&
      this.props.extradata.payway &&
      this.props.extradata.payway.gateway &&
      this.props.translations &&
      this.props.translations[this.props.extradata.payway.gateway]
    ) {
      gateway = converter.convertApaUnicode(
        this.props.translations,
        this.props.extradata.payway.gateway,
      );
    }

    // FIXME: get real countries from config
    const countries = ['dominicana', 'chile'];
    const region = constants.GetRegion();
    const subsData =
      this.props.user.paywayData &&
      this.props.user.paywayData.reduce(
        (p, c) => (c.purchase_data.purchase_id !== payway.purchase_id ? p : c),
        {},
      );

    if (countries.indexOf(region) === -1) {
      const old = textDesc;
      textDesc = converter.convertApaUnicode(
        this.props.translations,
        subsData.offer_text,
        old,
      );

    }

    if (Utils.isUser360()) {
      gateway = ' Claro 360';
    }

    if (this.props.extradata.payway.in_process_canceled) {
      const provedorRegionKeys =
        JSON.parse(this.props.accountConfiguration)[getRegion()] ||
        JSON.parse(this.props.accountConfiguration).default;

      const textKey = provedorRegionKeys.suscription.find(
        item => item.provider === this.props.extradata.provider,
      ).texts.default.offer_description;

      textDesc = converter.convertApaUnicode(
        this.props.translations,
        textKey.in_process_canceled,
      ).replace('{@EXPIRATION}',this.setExpirationDate());
    } else {
      textDesc = textDesc
        .replace('{@PROVIDER}', proveedor)
        .replace(
          '{@PRICE}',
          `${this.props.extradata.payway.currency} ${
            this.props.extradata.payway.price
          }`,
        )
        .replace('{@MEDIOPAGO}', gateway)
        .replace('{@EXPIRATION}', this.setExpirationDate());
    }

    const content = (
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h3 className="micuenta-title hasStickOnScroll">
                <strong>
                  {converter.convertApaUnicode(
                    this.props.translations,
                    this.props.extradata.title,
                    optionalTitle,
                  )}
                </strong>
              </h3>
            </div>
          </div>
        </div>

        {this.props.extradata.payway ? (
          <div className="col-lg-12 col-md-12" id="suscripcion_estado">
            <div className="row single-line">
              <div className="col-lg-12 col-md-12">
                <p
                  dangerouslySetInnerHTML={{
                    __html: textDesc,
                  }}
                />
              </div>
            </div>
            <div className="row">
              {this.props.extradata.payway.in_process_canceled === 0 && (
                <div>
                  <div className="col-lg-10 texto-gris padding-top-05">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: converter.convertApaUnicode(
                          this.props.translations,
                          this.props.extradata.texts &&
                            this.props.extradata.texts[texts] &&
                            this.props.extradata.texts[texts].offer_message
                              .purchased,
                          'Recuerda que tu suscripción se renovará automáticamente. Si deseas cancelar el servicio deberás hacerlo <b>24 horas antes</b> de la fecha de vencimiento. De esta manera evitarás que se te deduzcan nuevos cargos. ',
                        ),
                      }}
                    />
                  </div>
                  <div className="col-lg-2">
                    {!this.isItunes() && (
                      <button
                        id="btn_suspender"
                        type="button"
                        className="btn btn-default btn-block margin-top-05"
                        onClick={this.onCancel}
                      >
                        {converter.convertApaUnicode(
                          this.props.translations,
                          'profile_suscription_button_cancel',
                          'Cancelar Suscripci&oacute;n',
                        )}
                      </button>
                    )}
                  </div>
                </div>
              )}

              {this.props.extradata.payway.in_process_canceled === 1 && (
                <div>
                  <div className="col-lg-10 texto-gris padding-top-05">
                    <p>
                      {converter.convertApaUnicode(
                        this.props.translations,
                        this.props.extradata.texts &&
                          this.props.extradata.texts[texts] &&
                          this.props.extradata.texts[texts].offer_message
                            .in_process_canceled,
                        'Tu renovación automática fue suspendida con éxito.',
                      )}{' '}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <LoadingBlocks />
        )}
      </div>
    );
    return (
      <PanelClaro
        sectionName="micuentavtc"
        className="section-1 section-micuentavtc container mi-cuenta ficha"
      >
        {content}
      </PanelClaro>
    );
  }
}

UnSuscribeSection.propTypes = {
  fingerprint: PropTypes.string,
  claroPaymentData: PropTypes.shape({}),
  user: PropTypes.shape({
    paywayData: PropTypes.arrayOf(PropTypes.shape({})),
    info: PropTypes.shape({}),
  }),
  translations: PropTypes.PropTypes.shape({}),
  paywayData: PropTypes.arrayOf(PropTypes.shape({})),
  provider: PropTypes.string,
  showModal: PropTypes.func,
  extradata: PropTypes.shape({
    title: PropTypes.string,
    provider: PropTypes.string,
    texts: PropTypes.shape({
      itunesgate: PropTypes.shape({}),
      default: PropTypes.shape({}),
    }),
    payway: PropTypes.shape({
      in_process_canceled: PropTypes.number,
      purchase_id: PropTypes.string,
      price: PropTypes.string,
      currency: PropTypes.string,
      gateway: PropTypes.string,
      purchase_data: PropTypes.shape({
        price: PropTypes.string,
        currency: PropTypes.string,
      }),
    }),
  }),
  config: PropTypes.shape({
    skin: PropTypes.string,
  }),
};

UnSuscribeSection.defaultProps = {
  user: {},
  extradata: {},
};

const mapStateToProps = state => ({
  accountConfiguration: state.metadata.myaccount_configuration,
  translations: state.translations,
  user: state.user,
  config: state.config,
});

const mapDispatchToProps = {
  showModal: actions.showModal,
};

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(UnSuscribeSection);
